// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isCountryPerformanceRow = objectOf({
  country: string,
  currency: string,
  revenue_cents: number,
  purchases: number,
});

export const isGetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdResult = objectOf({
  country_performance: arrayOf(isCountryPerformanceRow),
});
